export const DISTANCE_FROM_BTN = 4
export const ARROW_SQUARE_WIDTH = 12
export const MOBILE_TOOLTIP_AUTO_CLOSE_TIME = 4000
export const ARROW_HORIZONTAL_TRANSFORM = 'translateX(-50%) rotate(45deg)'
export const ARROW_VERTICAL_TRANSFORM = 'translateY(-50%) rotate(45deg)'
